import { initializeModals } from "../modules/utils";

class UserDashboard {
  constructor(node) {
    this.element = node;
    this.userDashboardWrappers = this.element.querySelectorAll(".js-user-dashboard-wrapper");

    this.initialize();
  }

  initialize() {
    this.userDashboardWrappers.forEach((wrapper) => {
      wrapper.addEventListener("ajax:post", (e) => {
        wrapper.innerHTML = e.detail.html;
        initializeModals(wrapper);
        window.Beyuna.initClasses(wrapper);
      });
    });
  }
}

const dashboardElement = document.querySelector("[data-js='user-dashboard']");

if (dashboardElement) {
  new UserDashboard(dashboardElement);
}
